import React from "react";

import './ChartTable.scss';

const ChartTable = props => {
	const {headers, data, onRowClick} = props;

	const renderRow = (row) => {
		return headers.map((header, i) =>
			<div key={i} onClick={() => onRowClick(row, i)} className={`chart-table-row ${i< 1 ? 'chart-table-row-header' : ''}`}>{row[header]}</div>
		);
	};

	return (
		<div className="chart-table-container" style={{maxHeight: '300px'}}>
			{
				headers.map((header, i) =>
					<div key={i} className="chart-table-header">{header}</div>
				)
			}

			{ data.map(renderRow) }
		</div>
	)
};

export default ChartTable;